// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  backend: {
    baseURL: "https://admin.mygofacing.com/api"
  },
    firebase: {
      apiKey: "AIzaSyAn98Zab07jGUAV8-0oY2TGuAkaRA3UNW0",
      authDomain: "youforget-ewink.firebaseapp.com",
      projectId: "youforget-ewink",
      storageBucket: "youforget-ewink.appspot.com",
      messagingSenderId: "554403059232",
      appId: "1:554403059232:web:276fc0dfb0ced43dc04e45",
      measurementId: "G-HRNX9XYH6K"
    }
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
